// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FosterToggleController from "./foster_toggle_controller"
application.register("foster-toggle", FosterToggleController)

import TabScrollerController from "./tab_scroller_controller"
application.register("tab-scroller", TabScrollerController)
